// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"5b1888e0","99":"85a38147","168":"729e34f4","178":"2a953f66","305":"1426af10","543":"116028d6","705":"8afb562e","723":"872c21e0","924":"b80c5bdc"}[chunkId] + ".chunk.js";
};